import React from "react";
import "./blogs.css";
const Himanshu_Mishra = () => {
  return (
    <div className="blog">
      <div className="container-fluid">
        <div className="row blog-row">
          <div className="col-md-4">
            <img
              src="placement-postulates/dp/Himanshu-Mishra.jpg"
              className="blog-dp"
              alt="aryaman"
            ></img>
          </div>
          <div className="col-md-8">
            <div className="blog-head">
              <h2>Himanshu Mishra</h2>
              <small>Digital Consultant at Accenture Japan</small>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div>
              <p>Hello Everyone!</p>
              <p>
                I am Himanshu Mishra, will be joining Accenture Japan as a
                Digital Consultant. My 4 years (practically 2.5 years) at IIT
                Kanpur is just as exhilarating, with ups and downs like a roller
                coaster ride. There were thrilling moments mixed in with tense,
                anxious, frightened and triumphant ones. The college years are a
                truly surprising and delightful time in our lives, when we make
                numerous friends, finalize our careers, and prepare for the
                trials of the real world. But, if I have to conclude in one
                word, I will say “Life at campus is Beautiful”.
              </p>
              <p>
                {" "}
                <b> Resume:</b>. <br />
                One of the most exciting aspects of college life is the
                placement process, and it is critical to plan beforehand. Many
                of us are torn between continuing higher education or sitting
                for placements, or if we can do both. I will suggest in this
                situation: talk to your seniors and other important persons as
                soon as possible and make a decision (by August, atmost). I
                would also suggest starting early but even if you think it's too
                late to start properly at any point during your preparation,
                don't worry and get started right away. Because placements are,
                at the end of the day, fundamentally a competition, this will
                offer you an advantage.
              </p>
              <p>
                <img
                  class="blog-image-left"
                  src="placement-postulates/blogs/Himanshu-Mishra/1.jpg"
                />
                In terms of my own experience with this procedure, I'll start by
                underlining the importance of pre-placement preparation for the
                areas I was interested in. When I first started out, I figured
                out exactly which firms I wanted to work for, hence determining
                my preparation goals. I was mostly concerned with honing my
                coding skills, brushing up on my aptitude skills, and solving
                logic puzzles, as well as general interview preparation, such as
                HR and resume preparation. So, in the points below, I'll briefly
                go over my preparation:
              </p>
              <p>
                I started working on my résumé at the end of July, but I
                recommend getting started sooner. It was an ongoing process, and
                I made significant changes to my final draft after obtaining
                input from seniors and friends.This is when the advice to "start
                early" comes in help. You'll have more time to develop your
                resume if you start early. Remember that your CV serves as your
                initial impression. Make sure your CV is truthful and that you
                only include material that you can defend during the interview.
                Make a point of highlighting the influence you had on your
                projects/internships.
              </p>
              <p>
                Many students underestimate the aptitude test because of the
                difficulty and variety of problems yet passing the aptitude test
                is virtually always the first step toward interviews. I gave the
                prepleaf and pariksha aptitude tests. You can use CAT material
                if you want to be extra strict. This section will be a piece of
                cake if you practise often.
              </p>
              <p>
                {" "}
                <img
                  class="blog-image-right"
                  src="placement-postulates/blogs/Himanshu-Mishra/2.jpg"
                />
                I began practicing for the interview bit at the end of May and
                spent the most of my time learning algorithms and practicing
                coding problems. The essential principles learned in the ECS101
                course, together with the frequent coding I did as part of my
                department's curriculum, guaranteed that I felt comfortable with
                them.
              </p>
              <p>
                Companies' coding examinations begin in October, and the rest of
                the year will be filled with tests, PPTs, and interview
                preparation. I advise anyone interested in working for a coding
                company to begin their preparation as soon as possible. If you
                can use your summers to review Data Structures and Algorithms
                and solve leetcode problems, that would be fantastic. The
                majority of the questions will be based on Dynamic Programming,
                therefore prepare a lot of DP questions. Make certain you've
                covered all of the most common algorithms. Many of the questions
                are repeated from the previous year or from the company's visit
                to another college, so make sure you thoroughly answer previous
                questions before taking the examinations, as They are frequently
                the only basis for shortlisting. Because of its meticulousness,
                Geeks for Geeks has always been my go-to website for
                theory/solutions to specific concerns.
              </p>

              <p>
                I spent a couple of days preparing myself for puzzles, but it
                wasn't enough. I would advise treating puzzles with the same
                seriousness as aptitude preparation: practise on a regular
                basis. Geeks for Geeks and Brainstellers was the platform I used
                for my preparation. For my resume preparation, I went over all
                of the project reports and internship paperwork stated on my
                resume and had several resume grilling sessions with people I
                felt comfortable with and, more importantly, people I trusted to
                be completely honest with me. I created an HR document with
                tailored answers to a range of HR inquiries, both personal and
                company-related, as part of my HR preparation.
              </p>

              <p>
                {" "}
                <img
                  class="blog-image-left"
                  src="placement-postulates/blogs/Himanshu-Mishra/3.jpg"
                />
                On the Day of the interview, I reviewed the resume documents I
                had prepared and relaxed for the day, as my first interview was
                scheduled for Day 1, slot 2. I realized that while it's fine to
                feel apprehensive before an interview, it's critical to have
                your nerves calmed down throughout the interview.... My first
                interview was with Oracle, and it began with the interviewer
                asking me some data structures questions while glancing over my
                resume. I couldn't grasp the question, and I could already tell
                my interview was going south. He gave me several simple riddles
                to solve, and I answered them properly, but I had a sneaking
                suspicion that I had made a mistake. I was correct, and I was
                not invited back for another round. I ate lunch, drank water,
                and unwinded. I'm getting ready for the next interview.
              </p>
              <p>
                After giving my first interview, my nervousness vanished, and I
                felt more confident and relaxed. My next interview was with the
                MTX software profile. They asked me 3 to 4 coding questions and
                I answered them all. Then they have gone rigorously toward each
                and every point of my resume. They realized that I am struggling
                in OOPS, so they asked only OOPS for the next half an hour. My
                interview lasted for 1 hour and 45 minutes and I was totally
                exhausted. Although I cleared the first round, I was not in the
                mental state to go for the next. Second round was again very
                rigorous. They knew that I have good command over problem
                solving, so they started to give OOPS and machine learning
                related tasks. I answered some of them but at the same time
                failed to answer some as well. The second round made it clear
                that I am not getting an offer from the company. As soon as my
                second round of MTX interview got over, I got call for Accenture
                Japan Interview. I requested them to give me 5 minutes to
                breathe fresh air and get hydrated. I had two rounds in
                Accenture Japan. First round was a technical interview and the
                second round was a mix-up of both technical and HR. The first
                round started with a brief introduction about me and my
                interest. Then they grilled me over my resume. They have asked
                me questions from each point that I have mentioned in the
                project. They asked me the programming language in which I am
                comfortable with and then shooted the coding questions.
                Fortunately, I was able to solve the question. Then questions
                regarding OOPs, machine learning and data structures were asked
                and I was able to answer most of it. Then, I was called for the
                second round which was technical + HR round. It started again
                with general HR questions and ended up with common OOPs, Data
                Structure and Machine learning questions. This was short
                interview of about 25-30 minutes. The HR seems to be pleased
                from the interview which gives me some sense of selection which
                was confirmed by SPO later at night. After all of these
                rejections, it was exhilarating and terrifying to finally
                receive an offer, but the journey was well worth it. I'd like to
                emphasize a few random points and major takeaways from my
                experience:
              </p>
              <p>
                Have a plan, but don't become too committed to it because
                sometimes placements are based on luck, and things rarely happen
                as planned. Allow for the unexpected, keep your strategy
                flexible, and be prepared for the worst-case situation while
                hoping for the best. Concentrate on only a couple of profiles.
                Applying for every job profile under peer pressure or out of
                desperation will cut into your preparation time for the sectors
                you're really interested in, and if you get shortlisted for a
                lot of them, it'll clog up your schedule with tests and
                interviews you didn't plan on giving in the first place, as well
                as lead to unnecessary rejections that will dampen your spirits
                and physically exhaust you.
              </p>
              <p>
                You should keep going regardless of what occurs since "Day X"
                has a lot of preconceptions attached to it, and believe me, it
                doesn't matter whatever day you are placed on in terms of money
                or profile. You simply must be patient, as the entire procedure
                can be exhausting and frightening at times. You might get a lot
                of rejections but keep going because the rule of averages is
                genuine! Almost everyone who bothers to put up effort succeeds
                in the end. Please assist and sympathize with one another. The
                spirit of collaboration has always been our savior. If you have
                a great network of friends and support from numerous sources,
                you'll be amazed at how smoothly things will move. Once you've
                been placed, go out of your way to help your fellow classmates
                because you know how stressed they are.During these few months
                of the placement process, you will learn a lot and emerge a
                stronger person than you were before. Keep on; don't give up.
                You will succeed if you put yourself and your mental health
                first.
              </p>
              <img
                class="blog-image-right"
                src="placement-postulates/blogs/Himanshu-Mishra/4.jpg"
              />
              <h2 align="center">
                <b>Resources</b>
              </h2>
              <h3>
                <b>Coding:</b>
              </h3>
              <p>
                <ol>
                  <li>
                    {" "}
                    <a href="https://www.interviewbit.com/courses/programming/">
                      https://www.interviewbit.com/courses/programming/
                    </a>{" "}
                  </li>
                  <li>
                    {" "}
                    <a href="https://leetcode.com/problemset/algorithms/">
                      https://leetcode.com/problemset/algorithms/
                    </a>{" "}
                  </li>
                  <li>
                    For speed, Do Virtual contests on{" "}
                    <a href=" http://codeforces.com/contests">
                      {" "}
                      http://codeforces.com/contests
                    </a>{" "}
                  </li>
                  <li>
                    GFG -{" "}
                    <a href="https://www.geeksforgeeks.org/must-do-coding-questions-for-companies-like-amazon-microsoft-adobe/">
                      https://www.geeksforgeeks.org/must-do-coding-questions-for-companies-like-amazon-microsoft-adobe/
                    </a>{" "}
                  </li>
                </ol>
              </p>
              <h3>
                <b>Puzzles:</b>
              </h3>
              <p>
                <ol>
                  <li>50 challenging problems</li>
                  <li>brainstellar.com/</li>
                  <li>gurmeet.net</li>
                  <li>Ted Ed puzzles</li>
                </ol>
              </p>

              <h3>
                <b>Aptitude:</b>
              </h3>
              <p>
                <ol>
                  <li>Prep leaf</li>
                  <li>Pariksha</li>
                  <li>CAT Aptitude Question (additional)</li>
                </ol>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Himanshu_Mishra;
